import { ISimilarNewobject } from '../../types/similarNewobjects';
import { IGetNewbuildingsFromBuilderResponse } from 'shared/repositories/newbuilding-search/entities/get_newbuildings_from_builder/GetNewbuildingsFromBuilderResponse';
import { IGetRecommendationsResponse } from 'shared/repositories/newbuilding-search/entities/get_recommendations_by_newbuilding/GetRecommendationsResponse';
import { IRecommendationNewbuildingWithOfferStat } from 'shared/repositories/newbuilding-search/entities/recommendation_newbuilding/RecommendationNewbuildingWithOfferStat';

export function prepareSimilarNewobjects(
  response: IGetNewbuildingsFromBuilderResponse | IGetRecommendationsResponse,
): ISimilarNewobject[] {
  return response.newbuildings.map(prepareSimilarNewobjectsItem);
}

function prepareSimilarNewobjectsItem(item: IRecommendationNewbuildingWithOfferStat): ISimilarNewobject {
  return {
    address: item.address,
    developerLogoUrl: item.builder?.logoUrl ?? undefined,
    developerName: item.builder?.name,
    id: item.id,
    imageUrl: item.media[0]?.url ?? '',
    minPrice: item.minPriceRaw ?? 0,
    name: item.name,
    statusDisplay: item.status,
    undergroundInfo: item.underground
      ? {
          lineColor: item.underground.lineColor,
          name: item.underground.undergroundName,
          timeDisplay: item.underground.distance,
          transportType: item.underground.transportType,
          undergroundType: item.underground.undergroundType,
        }
      : null,
    url: item.url,
  };
}
